import { AnyAction } from "@reduxjs/toolkit";

import { AsyncEntity, EntityStatus } from "@tsp/utils/asyncEntity";

import { loadSupplierActualWorkTypesAction } from "../actions";
import { SupplierActualWorkType } from "../types";

export type SupplierWorkTypesStorePartState = {
  actualWorkTypes: AsyncEntity<Array<SupplierActualWorkType>>;
};

export type SupplierWorkTypesStorePart = {
  supplierWorkTypes: SupplierWorkTypesStorePartState;
};

const initialState: SupplierWorkTypesStorePartState = {
  actualWorkTypes: {
    status: EntityStatus.initial,
    data: [],
    error: null,
  },
};

export function supplierWorkTypesReducer(state = initialState, action: AnyAction): SupplierWorkTypesStorePartState {
  if (loadSupplierActualWorkTypesAction.started.match(action)) {
    return {
      ...state,
      actualWorkTypes: {
        ...state.actualWorkTypes,
        status: EntityStatus.fetching,
      },
    };
  }

  if (loadSupplierActualWorkTypesAction.done.match(action)) {
    return {
      ...state,
      actualWorkTypes: {
        ...state.actualWorkTypes,
        status: EntityStatus.fetched,
        data: action.payload.result,
      },
    };
  }

  return state;
}
